export default __webpack_public_path__ + "static/media/img_12.52313e85.jpg";